import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[appDebounce]'
})
export class DebounceDirective implements OnDestroy {

  @Input() debounceTimeMs: number = 500; // Default debounce time

  private readonly clicks = new Subject();
  private readonly subscription: Subscription;
  @Output()
  public appDebounceClick = new EventEmitter();
  constructor() {
    this.subscription = this.clicks.pipe(
      debounceTime(this.debounceTimeMs)
    ).subscribe(e => this.appDebounceClick.emit(e));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  onClick(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
